<template>
    <section class="publication">
        <div class="container">

            <div class="wrap-padding">
                <section class="filters" v-if="!breakpointDownMd">
                    <ul class="filtre-taaf-rnn">
                        <li v-for="(item, indexFilter) in filters" :key="indexFilter"><a href="" :class="{active: form.taxoId === item.id}"
                                                                @click.prevent="filtreSite(item.id)"
                                                                v-html="item.label"></a>
                        </li>
                    </ul>
                </section>
                <custom-select
                        class="mobile-custom-select"
                        value-field="id"
                        label-field="label"
                        :options="filters"
                        v-model="form.taxoId"
                        @change="filtreSite(null, true)"
                        v-if="breakpointDownMd"></custom-select>

                <div class="loader-wrap" v-if="loading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

                <div id="goto-result"></div>
                <div class="list-taxo" v-for="(item,indexTaxo) in result" :key="indexTaxo">
                    <h2 class="titre-rubrique" :class="{active: item.selected}" @click="toggleWrap(item, $event)">{{item.taxoName}}</h2>
                    <div class="list-wrap" :style="{display: item.selected ? 'block': 'none'}">
                        <article class="item publication"
                                 :class="{focus: form.page === 1}"
                                 :key="'key_'+indexChildPost"
                                 :data-index="indexChildPost"
                                 v-for="(item,indexChildPost) in item.childPost">
                            <div class="wrap-mobile">
                                <div class="bloc-titre">
                                    <h3 class="titre" v-html="item.title"></h3>
                                </div>
                                <div class="infos-file">
                                    <p>{{item.infosFile}}</p>
                                </div>
                                <div class="echeance">
                                    <p v-html="item.echeance"></p>
                                </div>
                            </div>
                            <div class="cta">
                                <a :href="item.url" class="simple" download=""><span class="icon-download"></span></a>
                            </div>
                        </article>
                    </div>

                    <div class="list-taxo" v-for="(subItems,indexChild) in item.subChildPost" v-if="subItems.childPost && subItems.childPost.length !== 0" :key="indexChildPost">
                        <h3 class="titre-rubrique" :class="{active: subItems.selected}" @click="toggleWrap(subItems, $event)">{{subItems.taxoName}}</h3>
                        <div class="editor" v-html="subItems.taxoDesc"></div>
                        <div class="list-wrap" style="display: none">

                            <article class="item publication"
                                     :class="{focus: form.page === 1 && indexChild === 0}"
                                     :key="'key_'+indexChildPostAnother"
                                     :data-indexChild="indexChild"
                                     v-for="(subItem,indexChildPostAnother) in subItems.childPost">
                                <div class="wrap-mobile">
                                    <div class="bloc-titre">
                                        <h3 class="titre" v-html="subItem.title"></h3>
                                    </div>
                                    <div class="infos-file">
                                        <p>{{subItem.infosFile}}</p>
                                    </div>
                                    <div class="echeance">
                                        <p v-html="subItem.echeance"></p>
                                    </div>
                                </div>
                                <div class="cta">
                                    <a :href="subItem.url" class="simple" download=""><span
                                            class="icon-download"></span></a>
                                </div>
                            </article>
                        </div>
                    </div>


                </div>
                <p v-if="result && result.length === 0" class="no-results">
                    <slot name="no-results"></slot>
                </p>
                <div class="clearfix"></div>
            </div>

        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"
    import {find} from "lodash"

    export default {
        mixins: [Ajax, Animation],
        props: {
            filters: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                result: [],
                loading: false,
                pagination: {},
                firstLoad: true,
                form: {
                    taxoId: "",
                },
            };
        },
        computed: {
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            formSubmit(form) {
                this.loading = true;
                this.result = null;
                if (form) {
                    this.form = form;
                }
                /*                if (!this.form.page) {
                                    this.form.page = 1;
                                }*/

                if (!this.firstLoad) {
                    Scrolling.scrollTo("#goto-result", "easeOutCubic", 600, 200);
                }

                this.ajax("publications", "getPublications", {form: this.form}).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.firstLoad = false

                    } else {
                        this.loading = false;
                        this.result = [];
                        this.firstLoad = false
                    }
                });


            },
            filtreSite(taxoId, mobile = false) {
                if (!mobile) {
                    this.form.taxoId = taxoId
                }
                let goodHash = find(this.filters, (o, index) => {
                    return o.id === this.form.taxoId
                });
                this.$router.push({hash: goodHash.slug})

                this.formSubmit()
            },
            getResume(item) {
                let link = "<a href=\"" + item.url + "\" class=\"more\">— Voir</a>";
                return item.summary_html + " " + link
            },
            initHashFilter() {
                if (this.$route.hash) {
                    let hash = this.$route.hash;
                    hash = hash.substr(1);

                    let goodFilter = find(this.filters, (o, index) => {
                        return o.slug === hash
                    });
                    this.form.taxoId = goodFilter.id
                }
            },
            toggleWrap(element, event) {
                element.oneTimeOpen = true
                element.selected = ! element.selected
                $(event.target).next('.list-wrap').slideToggle()
            }
        },
        created() {
            this.animDelta = 100
            if (this.filters.length > 0) {
                this.form.taxoId = this.filters[0].id
            }
        },
        mounted() {
            this.initHashFilter()
            this.formSubmit()
        },
        destroyed() {
        }
    };
</script>
